/**
 * « L'association reçoit … » des pages de don et de cagnotte — branché sur
 * les mêmes données que `usePaymentCalculations` (montant, couverture des
 * frais, soutien Donoor, prestataire), sans y toucher.
 * Calcul et raisons : utils/netAssociationEstime.ts.
 */
import type { Ref } from "vue";
import { detailNetAssociation } from "~/utils/netAssociationEstime";

interface Options {
  montant: Ref<number>;
  soutienDonoor: Ref<number>;
  couvreFrais: Ref<boolean>;
  tauxDonoor: Ref<number>;
  prestataire: Ref<"stripe" | "paypal">;
  paypalPourcent: Ref<number | undefined>;
  paypalFixe: Ref<number | undefined>;
}

/** `net`, `frais` (prestataire) et `commission` (Donoor) retirés du don. */
export function useNetAssociationEstime(o: Options) {
  return computed(() =>
    detailNetAssociation({
      montant: o.montant.value,
      soutienDonoor: o.soutienDonoor.value,
      couvreFrais: o.couvreFrais.value,
      tauxDonoor: o.tauxDonoor.value,
      prestataire: o.prestataire.value,
      paypalPourcent: o.paypalPourcent.value,
      paypalFixe: o.paypalFixe.value,
    }),
  );
}
